// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__EY5Qx","box":"Modal_box__3CnXA","xButton":"Modal_xButton__17QL0","continueButton":"Modal_continueButton__c655P"};